module.exports = __webpack_public_path__ + "media/images/blank-0c3174a883da84b248b35a2b2a81165c.gif";